// GTM dataLayer events. Fire only after a confirmed backend success. Never send PII.
window.dataLayer = window.dataLayer || [];

export function trackRewardlanceEvent(event, params = {}) {
  window.dataLayer.push({
    event,
    ...params
  });
}
window.trackRewardlanceEvent = trackRewardlanceEvent;

const SENT_KEY = "rl_tracked_events";
export function trackOnce(dedupeKey, event, params = {}) {
  let sent = [];
  try { sent = JSON.parse(localStorage.getItem(SENT_KEY) || "[]"); } catch { sent = []; }
  if (sent.includes(dedupeKey)) return;
  localStorage.setItem(SENT_KEY, JSON.stringify([...sent, dedupeKey].slice(-300)));
  trackRewardlanceEvent(event, params);
}

export const slug = (s) => String(s || "").toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");

export const roleName = (role) => ({ user: "contributor", business: "business" }[role]);

let regionMap;
export function countryCode(name) {
  const n = String(name || "").trim();
  if (/^[A-Za-z]{2}$/.test(n)) return n.toUpperCase();
  if (!regionMap) {
    regionMap = {};
    const dn = new Intl.DisplayNames(["en"], { type: "region" });
    const A = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (const a of A) for (const b of A) {
      const code = a + b;
      try { const label = dn.of(code); if (label && label !== code) regionMap[label.toLowerCase()] = code; } catch { /* not a region */ }
    }
    Object.assign(regionMap, { uk: "GB", "great britain": "GB", england: "GB", usa: "US", "united states of america": "US", uae: "AE", emirates: "AE" });
  }
  return regionMap[n.toLowerCase()];
}
